import { render } from "./IconSharingOpen.vue?vue&type=template&id=704e45e7"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconSharingOpen.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "704e45e7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('704e45e7', __exports__)) {
    api.reload('704e45e7', __exports__)
  }
  
  module.hot.accept("./IconSharingOpen.vue?vue&type=template&id=704e45e7", () => {
    api.rerender('704e45e7', render)
  })

}


export default __exports__